import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormField } from '@components/common';
import { Col, Row } from 'react-bootstrap';
import { isEqual, values } from 'lodash';
import { constants } from '../../utils';

class BankAccountForm extends Component {
	constructor(props) {
		super(props);

		this.fieldStyle = {
			fieldCol   : 12,
			labelCol   : 12,
			labelClass : 'margin-bottom-5 text-left',
			groupClass : 'margin-bottom-10',
		};

		this.bankAccountTypeOptions = values(constants.BANK_ACCOUNT_TYPES);
	}

	shouldComponentUpdate({ form }) {
		const lastProps = this.props;

		return !isEqual(form, lastProps.form);
	}

	render() {
		const { form, hideAccountType, onChange } = this.props;

		return (
			<div className="form-horizontal">
				<p className="small">
					<strong>Please Note</strong>
					: Two small deposits will be made to this account which may take 1-2 business days
					to appear on your online statement.  Return to payment account settings to confirm these amounts
					and verify this account.
				</p>
				<FormField
					fieldStyle={this.fieldStyle}
					name="bankHolderName"
					label="Account Holder Name"
					value={form.bankHolderName.value}
					validation={form.bankHolderName.validation}
					onChange={onChange('bankHolderName', 'field')}
				/>
				<FormField
					fieldStyle={this.fieldStyle}
					label="Routing Number"
					name="routingNo"
					value={form.routingNo.value}
					validation={form.routingNo.validation}
					onChange={onChange('routingNo', 'field')}
				/>
				<Row>
					<Col
						sm={6}
						md={6}
					>
						<FormField
							fieldStyle={this.fieldStyle}
							label="Account Number"
							name="accountNo"
							value={form.accountNo.value}
							validation={form.accountNo.validation}
							onChange={onChange('accountNo', 'field')}
						/>
					</Col>
					<Col
						sm={6}
						md={6}
					>
						<FormField
							fieldStyle={this.fieldStyle}
							label="Confirm Account Number"
							name="accountNo_confirmation"
							value={form.accountNo_confirmation.value}
							validation={form.accountNo_confirmation.validation}
							onChange={onChange('accountNo_confirmation', 'field')}
						/>
					</Col>
				</Row>
				<If condition={!hideAccountType}>
					<FormField
						fieldStyle={this.fieldStyle}
						controlType="select"
						options={this.bankAccountTypeOptions}
						label="Account Type"
						name="accountType"
						value={form.accountType.value}
						validation={form.accountType.validation}
						onChange={onChange('accountType', 'select')}
						placeholder="Select..."
						isClearable={false}
					/>
				</If>
			</div>
		);
	}
}

BankAccountForm.propTypes = {
	form            : PropTypes.object.isRequired,
	hideAccountType : PropTypes.bool,
	onChange        : PropTypes.func.isRequired,
};

BankAccountForm.defaultProps = {
	hideAccountType : false,
};

export default BankAccountForm;
